import * as yup from "yup";

import { validator as additionalDataValidator } from "./AdditionalData/validator";
import { validator as imagesDescriptionDataValidator } from "./ImagesDescriptionData/validator";

export const validator = yup.object({
  ...imagesDescriptionDataValidator,
  ...additionalDataValidator,
});
